import { useState, createElement, forwardRef } from "react";
import Popup from '../colorful-popup';
import classNames from "classnames";
import './index.scss';
import { mergeProps } from "../../utils/with-default-props";
const defaultProps = {
    visible: false,
    title: '标题',
    titleColor: '#fff',
    titleBgColor: '#4496e6',
    titleSize: '14px',
    options: [{ label: '蓝猫', value: 'blue' }, { label: '美短', value: 'mei' }],
    showSuccessBtn: false,
    successBtnColor: 'blue',
    successBtnSize: '14px',
    showDivide: true,
};
const ColorfulSelect = forwardRef((p, ref) => {
    const props = mergeProps(defaultProps, p);
    const { visible, title, selected, onChange } = props;
    const prefixCls = 'au-droplist';
    const addCls = string => `${prefixCls}${string}`;
    const [value, setValue] = useState(selected);
    const onChangeSelect = (val) => {
        setValue(val);
        onChange && onChange(val);
    };
    return (createElement(Popup, { mask: true, visible: visible, position: "bottom", className: addCls('') },
        createElement("div", { className: addCls('-inner') },
            createElement("div", { className: addCls('-title'), style: {
                    color: props.titleColor,
                    fontSize: props.titleSize,
                    backgroundColor: props.titleBgColor
                } },
                createElement("span", { className: addCls('-title-text') }, title),
                props.successText && (createElement("span", { className: addCls('-title-btn'), style: {
                        color: props.successBtnColor,
                        fontSize: props.successBtnSize
                    } }, props.successText))),
            createElement("ul", { className: addCls('-list') }, props.options.map(_ => (createElement("li", { key: _?.value, className: classNames(addCls('-item'), {
                    [addCls('-divide')]: props.showDivide
                }), onClick: () => onChangeSelect(_.value) },
                createElement("span", { className: addCls('-text'), style: {
                        color: props.optionColor,
                        fontSize: props.optionSize
                    } }, _?.label),
                createElement("span", { className: addCls('-icon') },
                    value === _?.value && props.checkIcon,
                    value === _?.value && !props.checkIcon && (createElement("i", { className: addCls('-icon-checked') },
                        createElement("i", { className: addCls('-icon-inner') })))))))))));
});
ColorfulSelect.displayName = 'ColorfulSelect';
export default ColorfulSelect;
